import { ArtistTourType } from '@api';
import { StatusBadge } from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';
import { TourTableCell } from './components';

export type UseArtistShowsColumnsReturnType = {
  columns: DataTableColumn<ArtistTourType>[];
};

export const useArtistShowsColumns = (): UseArtistShowsColumnsReturnType => {
  const { t } = useTranslation();

  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER');

  const columns: DataTableColumn<ArtistTourType>[] = [
    {
      accessor: 'tour',
      render: (record) => <TourTableCell record={record} />,
    },
    {
      accessor: 'status',
      render: (record) => <StatusBadge status={record.status} />,
    },
    {
      accessor: 'production',
      render: (record) => record.production ?? noDataPlaceholder,
    },
    {
      accessor: 'showSetup',
      render: (record) => record.showSetup ?? noDataPlaceholder,
    },
    {
      accessor: 'configuration',
      render: (record) => record.configuration ?? noDataPlaceholder,
    },
    {
      accessor: 'tourYear',
    },
  ];

  return { columns };
};
